import { useEffect, useState } from 'react';

// Visibility classes, migrated from <body> ng-class directive
// eslint-disable-next-line func-params-args/func-params
export const useBodyVisibilityClasses = (
  loaded: boolean,
  done: boolean,
  isReadOnly: boolean,
  hasError: boolean,
): void => {
  const [isPainted, setPainted] = useState(false);

  /**
   * This snippet is required because we have no way to ensure the React tree has been
   * rendered and reconciled with the DOM at any given point in time. As such, we are
   * using a canary element (`.top-menu`) to symbolize that React has reconciled with
   * the DOM and that we can finally hide the skeleton loader.
   *
   * Removing this means that we will start seeing a white screen when the skeleton
   * loader fades away: the recording is "loaded" but the browser has not painted the
   * React tree.
   */
  useEffect(() => {
    if (!loaded && !hasError) return;

    const topMenu = document.querySelector('.top-menu');
    if (topMenu || hasError) {
      setPainted(true);
      return;
    }

    const observer = new MutationObserver((mutations) => {
      const painted = mutations.some((mutation) => {
        let topMenuInserted = false;
        mutation.addedNodes.forEach((node) => {
          if (topMenuInserted) return;
          topMenuInserted = (node as HTMLElement).classList?.contains('top-menu');
        });

        return topMenuInserted;
      });
      if (!painted) return;

      setPainted(true);
      observer.disconnect();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }, [loaded, hasError]);

  useEffect(() => {
    document.body.classList.toggle('done', done);
    document.body.classList.toggle('readonly', isReadOnly);
    document.body.classList.toggle('loaded', loaded || hasError);

    const fakePlayer = document.getElementById('fake-recording-player');
    if ((loaded || hasError) && isPainted && fakePlayer) fakePlayer.style.opacity = '0';
  }, [isPainted, loaded, done, isReadOnly, hasError]);
};
